module.exports = __webpack_public_path__ + "static/img/bg_ptzx.8d71071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_ptzx.png
// module id = Xquz
// module chunks = 19